import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A short run of wooden fence — posts joined by two horizontal rails.
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/fence.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ box, seed }) => {
    const wood = shade(0x9c7b4a, (rand(seed) - 0.5) * 0.15);
    const posts = 3 + Math.floor(rand(seed + 1) * 2);
    const span = 1.2;
    const x0 = -((posts - 1) * span) / 2;
    for (let i = 0; i < posts; i++) {
      const x = x0 + i * span;
      box(x, 0.5, 0, 0.16, 1.0, 0.16, shade(wood, -0.05)); // post
      if (i < posts - 1) {
        box(x + span / 2, 0.7, 0, span, 0.1, 0.08, wood);  // top rail
        box(x + span / 2, 0.4, 0, span, 0.1, 0.08, wood);  // bottom rail
      }
    }
  };

export default build;
